export const theme = {
  light: {
    font: "black",
    background:
      "linear-gradient(rgb(110, 218, 237),  rgba(251, 255, 0, 0.228), white, white)",
    borderColor: "black",
    cardBoxShadow: "0px 10px 50px rgba(0, 0, 0, 1)",
  },

  dark: {
    font: "white",
    blue: "#63cdff",
    background: "black",
    borderColor: "white",
    textShadow: "0 0 10px #63cdff, 0 0 10px #63cdff",
    textShadowHidden:
      "0 0 10px #63cdff, 0 0 20px #63cdff, 0 0 40px #63cdff, 0 0 80px #63cdff, 0 0 160px #63cdff",
    textReflect: "below -140% linear-gradient(#0003, #000)",
    textReflectHidden: "below 0 linear-gradient(#0002, #0008)",
    cardBoxShadow:
      "0px 0px 20px #63cdff, 0px 0px 20px #63cdff, 0px 0px 20px #63cdff",
  },

  display: {
    block: "block",
    none: "none",
  },
}
